import { Stack, TextField } from '@fluentui/react';
import { useCallback, useEffect, useState } from 'react';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
};

const LocationInput = ({ label, value, onChange, required }: Props) => {
  const [line1, setLine1] = useState('');
  const [suburb, setSuburb] = useState('');
  const [state, setState] = useState('');
  const [postcode, setPostcode] = useState('');

  const handleChange = useCallback((val: string, set: (v: string) => void) => {
    set(val.replace(/\s*,\s*/g, ' '));
  }, []);

  useEffect(() => {
    const [line1, suburb, state, postcode] = value.split(', ');
    setLine1(line1 || '');
    setSuburb(suburb || '');
    setState(state || '');
    setPostcode(postcode || '');
  }, [value]);

  useEffect(() => {
    let loc = '';
    if (line1 || suburb || state || postcode) {
      loc = `${line1}, ${suburb}, ${state}, ${postcode}`;
    }

    if (loc && loc != value) {
      onChange(loc);
    }
  }, [line1, onChange, postcode, state, suburb, value]);

  return (
    <Stack style={{ marginBottom: '8px' }}>
      <label style={{ marginBottom: '2px' }}>
        {label}
        {required && <sup style={{ color: 'red' }}>*</sup>}
      </label>
      <Stack style={{ gap: '8px' }}>
        <TextField
          //className={className}
          placeholder="Address"
          type="text"
          value={line1}
          onChange={(_, val) => handleChange(val ?? '', setLine1)}
          onKeyUp={e => handleChange(e.currentTarget.value, setLine1)}
        />
        <Stack horizontal style={{ gap: '8px' }}>
          <TextField
            //className={className}
            placeholder="Suburb"
            type="text"
            value={suburb}
            onChange={(_, val) => handleChange(val ?? '', setSuburb)}
            onKeyUp={e => handleChange(e.currentTarget.value, setSuburb)}
          />
          <TextField
            //className={className}
            placeholder="State"
            type="text"
            value={state}
            onChange={(_, val) => handleChange(val ?? '', setState)}
            onKeyUp={e => handleChange(e.currentTarget.value, setState)}
          />
          <TextField
            //className={className}
            placeholder="Postcode"
            type="text"
            value={postcode}
            onChange={(_, val) => handleChange(val ?? '', setPostcode)}
            onKeyUp={e => handleChange(e.currentTarget.value, setPostcode)}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default LocationInput;
